import { merge } from 'lodash'

import { theme } from '.'

export const purpleTheme = merge({}, theme, {
  components: {
    Button: {
      variants: {
        primary: {
          color: 'white',
          bg: 'primary.purple.60',
          '&:hover': {
            bg: 'primary.purple.70',
          },
          '&:active': {
            bg: 'primary.purple.70',
          },
        },
        primarySmall: {
          color: 'white',
          bg: 'primary.purple.60',
          '&:hover': {
            bg: 'primary.purple.70',
          },
          '&:active': {
            bg: 'primary.purple.70',
          },
        },
        secondary: {
          color: 'white',
          bg: 'primary.purple.80',
          '&:hover': {
            bg: 'primary.purple.90',
          },
        },
        secondarySmall: {
          color: 'white',
          bg: 'primary.purple.80',
          '&:hover': {
            bg: 'primary.purple.90',
          },
        },
        image: {
          color: 'white',
        },
        outline: {
          color: 'white',
        },
        card: {
          color: 'white',
        },
      },
    },
    Text: {
      variants: {
        footerLink: {
          color: 'white',
        },
      },
    },
    Heading: {
      variants: {
        subheading: {
          color: 'white',
        },
      },
    },
  },
  colors: {
    primary: {
      teal: {
        100: '#1D1E3C',
        80: '#2E3161',
        60: '#7F82E6',
        40: '#a1a1e2',
        30: '#7F80AF',
        15: '#A1A3CC',
        10: '#B5B7D9',
        5: '#D1D3EB',
      },
      darkGreen: {
        100: '#1D1E3C',
        80: '#4A4C86',
        60: '#66689B',
        50: '#7F82E6',
        40: '#7F80AF',
        20: '#A1A3CC',
        15: '#B5B7D9',
        10: '#D1D3EB',
      },
      purple: {
        100: '#1D1E3C',
        90: '#1F2142',
        80: '#2E3161',
        70: '#5053DD',
        60: '#595CDF',
        50: '#7F82E6',
      },
    },
  },
})
